import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Role;
export const entityOperations = [
  Operation.getAll,
];
